import toast from "components/partials/toast/toast";

import { usePublishBeeConfigs } from "hooks/api/use-bee-config";
import { useCurrentClient } from "hooks/api/use-clients";
import { useThemeQuery } from "hooks/api/use-theme";

import { themeToBeeConfigs } from "containers/admin/clients/client/theme-configuration-page/helpers/bee-configs";

export const usePublishTheme = () => {
  const client = useCurrentClient();
  const { data: theme, isLoading } = useThemeQuery(client.id);
  const publishBeeConfigs = usePublishBeeConfigs(client.id);

  const handlePublish = async () => {
    try {
      const configs = themeToBeeConfigs(theme);

      if (configs) {
        await publishBeeConfigs.mutateAsync(configs);
      }
    } catch (error) {
      console.error("Failed to publish theme configs:", error);
      toast.error({ data: { title: "Failed to publish theme" } });
    }
  };

  return {
    isPublishDisabled: isLoading,
    isPublishing: publishBeeConfigs.isPending,
    handlePublish,
  };
};
